export const isAuthenticated = () => {
  const token = localStorage.getItem("accessToken");
  return !!token; // Devuelve true si hay un token
};